(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["404"]) return;
  try {
    
  const marquee = document.querySelector('.marquee');
  const track = marquee.querySelector('.marquee-track');
  const group = marquee.querySelector('.marquee-group');

  // Clone automatically
  const clone = group.cloneNode(true);
  clone.setAttribute('aria-hidden', 'true');
  track.appendChild(clone);

  // Calculate speed based on width
  const pixelsPerSecond = 200;
  const distance = group.offsetWidth;
  const duration = distance / pixelsPerSecond;

  gsap.to(track, {
    x: -distance,
    duration: duration,
    ease: 'none',
    repeat: -1,
  });

  gsap.to('.err-header', {
    scale: 1.05,
    duration: 1.5,
    yoyo: true,
    repeat: -1,
  });

  gsap.from('.err-header', {
    yPercent: 40,
    opacity: 0,
    duration: 1.25,
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-custom-packets"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    gsap.registerPlugin(ScrollTrigger);

    const section = document.querySelector('#custom-image-section');

    if (!section) return;

    const images = section.querySelectorAll('img');

    const isMobile = window.matchMedia('(max-width: 749px)').matches;

    const finalPositions = isMobile
      ? [
          { xPercent: -125, y: -30, rotation: -12 },
          { xPercent: -95, y: -55, rotation: -6 },
          { xPercent: -50, y: -65, rotation: 0 },
          { xPercent: -5, y: -55, rotation: 6 },
          { xPercent: 25, y: -30, rotation: 12 },
        ]
      : [
          { xPercent: -190, y: -55, rotation: -14 },
          { xPercent: -110, y: -100, rotation: -7 },
          { xPercent: -50, y: -110, rotation: 0 },
          { xPercent: 30, y: -100, rotation: 7 },
          { xPercent: 110, y: -55, rotation: 14 },
        ];

    gsap.set(images, {
      xPercent: -50,
      y: 80,
      rotation: 0,
      scale: 0.9,
    });

    gsap.to(images, {
      xPercent: (index) => finalPositions[index].xPercent,
      y: (index) => finalPositions[index].y,
      rotation: (index) => finalPositions[index].rotation,
      scale: 1,
      duration: 1.2,
      ease: 'power3.out',
      stagger: 0.08,
      scrollTrigger: {
        trigger: section,
        start: 'top 75%',
      },
    });
  });

  } catch(e) { console.error(e); }
})();
})();
